import React, { useEffect } from "react";
import confetti from "canvas-confetti";
import { X } from "lucide-react";

export default function AchievementModal({ achievements, onClose }) {
  const ach = achievements[0];

  useEffect(() => {
    const end = Date.now() + 2500;
    const colors = ["#1A4D2E", "#86c559", "#3d6b1f", "#d4a574", "#f0d080"];
    const interval = setInterval(() => {
      if (Date.now() > end) { clearInterval(interval); return; }
      confetti({
        particleCount: 25,
        spread: 70,
        startVelocity: 35,
        origin: { x: Math.random() * 0.6 + 0.2, y: 0.45 },
        colors,
        gravity: 0.9,
      });
    }, 180);
    return () => clearInterval(interval);
  }, []);

  if (!ach) return null;

  return (
    <div
      data-testid="achievement-modal"
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 100,
        background: "rgba(0,0,0,0.65)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          background: "rgba(255,255,255,0.97)",
          borderRadius: "1.5rem",
          padding: "2.5rem 2rem 2rem",
          textAlign: "center",
          maxWidth: "360px", width: "90%",
          boxShadow: "0 24px 64px rgba(26,77,46,0.28), 0 4px 16px rgba(0,0,0,0.1)",
          border: "1px solid rgba(255,255,255,0.8)",
        }}
      >
        <button
          data-testid="achievement-modal-close"
          onClick={onClose}
          style={{
            position: "absolute", top: "1rem", right: "1rem",
            background: "rgba(26,77,46,0.06)", border: "1px solid rgba(26,77,46,0.12)",
            borderRadius: "50%", width: "28px", height: "28px",
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer", color: "#6b7280",
          }}
        >
          <X size={14} />
        </button>

        {/* Achievement icon */}
        <div style={{ fontSize: "3.5rem", marginBottom: "0.75rem", lineHeight: 1 }}>
          {ach.icon}
        </div>

        {/* Badge */}
        <div style={{
          display: "inline-block",
          background: "rgba(26,77,46,0.08)",
          color: "#1A4D2E",
          fontSize: "0.6rem", fontWeight: 700,
          textTransform: "uppercase", letterSpacing: "0.12em",
          borderRadius: "2rem", padding: "0.2rem 0.8rem",
          marginBottom: "0.875rem",
          fontFamily: "'Manrope', sans-serif",
          border: "1px solid rgba(26,77,46,0.15)",
        }}>
          Achievement Unlocked
        </div>

        {/* Title */}
        <h2 style={{
          fontFamily: "'Manrope', sans-serif",
          color: "#1A4D2E", fontSize: "1.5rem", fontWeight: 800,
          margin: "0 0 0.5rem",
        }}>
          {ach.title}
        </h2>

        {/* Description */}
        <p style={{
          fontFamily: "'Manrope', sans-serif",
          color: "#6b7280", fontSize: "0.875rem",
          margin: "0 0 1.25rem", lineHeight: 1.5,
        }}>
          {ach.desc}
        </p>

        {/* XP reward */}
        {ach.xp > 0 && (
          <div style={{
            display: "inline-flex", alignItems: "center", gap: "0.35rem",
            background: "rgba(26,77,46,0.08)",
            border: "1px solid rgba(26,77,46,0.18)",
            color: "#1A4D2E", borderRadius: "2rem",
            padding: "0.45rem 1.1rem",
            fontFamily: "'Manrope', sans-serif", fontWeight: 800, fontSize: "1.1rem",
            marginBottom: "1.25rem",
          }}>
            +{ach.xp} XP
          </div>
        )}

        {/* More achievements hint */}
        {achievements.length > 1 && (
          <p style={{
            fontFamily: "'Manrope', sans-serif",
            color: "#6b7280", fontSize: "0.78rem",
            margin: "0 0 1rem",
          }}>
            +{achievements.length - 1} more achievement{achievements.length > 2 ? "s" : ""} unlocked!
          </p>
        )}

        <button
          data-testid="achievement-modal-dismiss"
          onClick={onClose}
          style={{
            background: "#1A4D2E", color: "#fff",
            border: "none", borderRadius: "3rem",
            padding: "0.75rem 2.5rem",
            fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: "0.95rem",
            cursor: "pointer",
            boxShadow: "0 4px 20px rgba(26,77,46,0.3)",
            transition: "background 0.2s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#143D24")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "#1A4D2E")}
        >
          Awesome!
        </button>
      </div>
    </div>
  );
}
